/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import useUsuarios from "../../hooks/useUsuarios";
import ModalAdd from "./Modals/ModalAdd";
import ModalPassword from "./Modals/ModalPassword";
import DataTable from "../../components/DataTable/DataTable";
import Title from "../../components/Form/Title";
import ReadOnlyNote from "../../components/Form/ReadOnlyNote";
import { hideLoader, showLoader, setTitle } from "../../reducers/loaderReducer";
import { useDispatch } from "react-redux";
import useLogin from "../../hooks/useLogin";
import Swal from "sweetalert2";

const ROLE_LABELS = {
  "super administrador": "Super admin",
  administrador: "Administrador",
  contabilidad: "Contabilidad",
  proveedor: "Proveedor",
  cliente: "Cliente",
};

export default function Index() {
  const { token, user_rol } = useLogin();
  const dispatch = useDispatch();
  const { loading, error, Usuarios, UsuariosGetService, UsuariosDeleteService, success, message } = useUsuarios();
  const [modal, setModal] = useState(false);
  const [Update, setUpdate] = useState(false);
  const [Id, setId] = useState("");
  const [Nombre, setNombre] = useState("");
  const [Correo, setCorreo] = useState("");
  const [Rol, setRol] = useState("");
  const [Status, setStatus] = useState("");
  const [modalPassword, setModalPassword] = useState(false);
  const [PasswordId, setPasswordId] = useState("");
  const [PasswordNombre, setPasswordNombre] = useState("");
  const canManage = user_rol === "super administrador" || user_rol === "cliente";

  const toggle = () => {
    setModal(!modal);
    setUpdate(false);
    setId("");
    setNombre("");
    setCorreo("");
    setRol("");
    setStatus("");
  };

  const togglePassword = () => {
    setModalPassword(!modalPassword);
  };

  useEffect(() => {
    dispatch(setTitle("Descargando usuarios"));
    dispatch(showLoader());
    UsuariosGetService(token);
    return () => { };
  }, []);

  useEffect(() => {
    if (Usuarios.length > 0) {
      dispatch(hideLoader());
      dispatch(setTitle(""));
    }
    return () => { };
  }, [Usuarios]);

  useEffect(() => {
    if (success === true) {
      UsuariosGetService(token);
    }
  }, [UsuariosGetService, success]);

  const Eliminar = (e) => {
    Swal.fire({
      title: "¿Eliminar usuario?",
      text: "Esta acción no se puede deshacer.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#dc2626",
      cancelButtonColor: "#3b82f6",
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
    }).then((resultado) => {
      if (!resultado.isConfirmed) return;

      const data = new FormData();
      data.append("id", e);
      UsuariosDeleteService(data, token);

      Swal.fire({
        title: "Espere por favor...",
        text: "Cargando...",
        allowEscapeKey: false,
        allowOutsideClick: false,
        showConfirmButton: false,
        icon: 'question',
        onOpen: () => {
          Swal.showLoading();
        }
      });
    });
  }

  useEffect(() => {
    if (success) {
      Swal.close();
      Swal.fire({
        icon: "success",
        title: "Exito",
        confirmButtonColor: "#3b82f6",
        text: message,
      });
    }
  }, [message, success])

  useEffect(() => {
    if (error) {
      Swal.close();
      Swal.fire({
        icon: "error",
        title: "Error",
        confirmButtonColor: "#3b82f6",
        text: message,
      });
    }
  }, [message, error])

  const columns = [
    { field: "name", title: "Nombre" },
    { field: "email", title: "Correo" },
    {
      field: "rol",
      title: "Rol",
      align: "center",
      filterValue: (row) => ROLE_LABELS[row.rol] || row.rol,
      render: (row) => {
        const slug = (row.rol || "").replace(/\s+/g, "-");
        return (
          <span className={`crud-role-badge rol-${slug}`}>
            {ROLE_LABELS[row.rol] || row.rol}
          </span>
        );
      },
    },
    {
      field: "status",
      title: "Estatus",
      align: "center",
      render: (row) => (
        <span
          className={`crud-badge ${
            row.status === "Activo" ? "status-activo" : "status-cancelado"
          }`}
        >
          {row.status}
        </span>
      ),
    },
  ];

  if (canManage) {
    columns.push({
      field: "Acciones",
      title: "Acciones",
      align: "center",
      sortable: false,
      filterable: false,
      render: (row) => (
        <div className="crud-actions">
          <button
            className="crud-icon-btn edit"
            title="Editar"
            onClick={() => {
              setId(row.id);
              setNombre(row.name);
              setCorreo(row.email);
              setRol(row.rol);
              setStatus(row.status);
              setUpdate(true);
              setModal(true);
            }}
          >
            <i className="bi bi-pencil"></i> Editar
          </button>
          <button
            className="crud-icon-btn password"
            title="Restablecer contraseña"
            onClick={() => {
              setPasswordId(row.id);
              setPasswordNombre(row.name);
              setModalPassword(true);
            }}
          >
            <i className="bi bi-key"></i> Contraseña
          </button>
          <button
            className="crud-icon-btn delete"
            title="Eliminar"
            onClick={() => {
              Eliminar(row.id);
            }}
          >
            <i className="bi bi-trash"></i> Eliminar
          </button>
        </div>
      ),
    });
  }

  return (
    <>
      <ModalAdd
        modal={modal}
        toggle={toggle}
        Nombre={Nombre}
        Correo={Correo}
        Rol={Rol}
        Status={Status}
        Update={Update}
        Id={Id}
        token={token}
        setNombre={setNombre}
        setCorreo={setCorreo}
        setRol={setRol}
        setStatus={setStatus}
        UsuariosGetService={UsuariosGetService}
      />
      <ModalPassword
        modal={modalPassword}
        toggle={togglePassword}
        Id={PasswordId}
        Nombre={PasswordNombre}
        token={token}
      />
      <div className="container">
        <div className="crud-header">
          <Title title="Listado de Usuarios" className="crud-title" />
          {canManage ? (
            <button className="crud-add-btn" onClick={toggle}>
              <i className="bi bi-plus-lg"></i>
              Agregar usuario
            </button>
          ) : (
            <ReadOnlyNote />
          )}
        </div>
        <div className="crud-card">
          <DataTable tableKey="usuarios" loading={loading} columns={columns} data={Usuarios} />
        </div>
      </div>
    </>
  );
}
